import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from './article-video.module.scss';
import { ArticleVideoInterface } from './article-video.interface';

/**
 * поддерживаеме ссылки:
 * https://youtu.be/dpw9EHDh2bM
 * https://www.youtube.com/watch?v=dpw9EHDh2bM
 * https://www.facebook.com/facebook/videos/328625588284314/
 * https://www.facebook.com/watch/?v=328625588284314
 */
export const parseEmbedVideoUrl = (url: string): string => {
  const videoId = url.match(/(?:\?v=)|(?:(?:youtu.be|videos?)\/)([^&#\n\s/]*)/)?.[1];
  const videoSourceData = [
    {
      regexp: /(youtu.be|youtube.com)\//,
      prefix: 'https://www.youtube.com/embed/',
    },
    {
      regexp: /facebook.com/,
      prefix: 'https://www.facebook.com/v2.3/plugins/video.php?href=https://www.facebook.com/watch/?v=',
    }
  ].find(thisSource => thisSource.regexp.test(url));

  return (
    videoId
    && videoSourceData
  )
    ? `${videoSourceData.prefix}${videoId}`
    : url;
}

const ArticleVideo: React.FunctionComponent<ArticleVideoInterface> = ({
  className,
  videoUrl,
  children,
  ...props
}) => {
  const [shouldLoad, setShouldLoad] = useState(false);

  const shouldSplitCaption = typeof children === 'string'
    && children.split(' ').length < 3;

  useEffect(() => {
    setTimeout(() => setShouldLoad(true), 100);
  }, []);

  return (
    <figure
      {...props}
      className={classNames(
        styles.component,
        className,
      )}
    >
      {shouldLoad
        ? (
          <iframe
            className={styles.iframe}
            src={parseEmbedVideoUrl(videoUrl)}
            title={children?.toString()}
            allowFullScreen
          />
        )
        : <div className={styles.iframe} />
      }

      <figcaption className={styles.caption}>
        {shouldSplitCaption
          ? children.replace(/\s/g, '\n')
          : children
        }
      </figcaption>
    </figure>
  );
};

export default ArticleVideo;
